/**
 * Page = xyflow Node. The sitemap canvas treats each Page as a node;
 * `node.data` carries the page's grid + slug + SEO.
 *
 * `position` mirrors xyflow.Node — the canvas coordinate the user
 * placed this page at. Drives the sitemap layout, not the rendered URL
 * (URL is from `data.slug`).
 */
import * as Schema from "effect/Schema";

import { PageId } from "./ids.js";
import { SeoMeta } from "./seo.js";
import { Slug } from "./slug.js";
import { GridWidgetContent } from "./widgets/grid.js";

export const NodePosition = Schema.Struct({
  x: Schema.Number,
  y: Schema.Number,
});
export type NodePosition = Schema.Schema.Type<typeof NodePosition>;

/**
 * PageData — the `data` field of the xyflow Node. Holds the page's
 * grid, slug, and SEO. The grid is always a single top-level
 * GridWidgetContent (12 columns by convention); nested grids show up
 * as child widgets inside the top-level grid's items.
 */
export const PageData = Schema.Struct({
  slug: Slug,
  title: Schema.String,
  grid: GridWidgetContent,
  seo: SeoMeta,
});
export type PageData = Schema.Schema.Type<typeof PageData>;

export const Page = Schema.Struct({
  id: PageId,
  position: NodePosition,
  data: PageData,
});
export type Page = Schema.Schema.Type<typeof Page>;
